import React from "react";
import { Box, Button, Typography, useMediaQuery } from "@mui/material";
import investekLogo from "../assets/Logo-investek.png";
import { useNavigate } from "react-router-dom";
import PhoneIcon from "@mui/icons-material/Phone";
import MailIcon from "@mui/icons-material/Mail";
// import firstBackground from "../assets/firstBackground.png";

const Signup = () => {
  const isSmallScreen = useMediaQuery("(max-width:600px)");

  const navigate = useNavigate();
  const handleSignup = () => {
    navigate("/register");
  };
  const handleSignin = () => {
    navigate("/signin");
  };
  const handleContactus = () => {
    window.open("https://www.investek.in/contact", "_blank");
  };
  return (
    <>
      {isSmallScreen ? (
        <span>
          <Box sx={styles.formboxresponsive}>
            <Box>
              <img src={investekLogo} alt="img" />
              <Typography sx={{ fontSize: "20px" }}>
                <b>Amigo team welcomes you!</b>
              </Typography>
              <div>Would you like to refer a friend / family member?</div>
              <Button sx={styles.btn} variant="text" onClick={handleSignup}>
                Sign Up
              </Button>
            </Box>
            <Box>
              <Typography sx={{ fontSize: "20px" }}>
                <b>Would you like to know about our</b>
              </Typography>
              <div>Referral Reward Program?</div>
              <Button onClick={handleContactus} sx={styles.btn} variant="text">
                Contact Us
              </Button>
            </Box>
            <Box>
              <div>
                <a
                  style={{
                    color: "#002c51",
                    fontSize: "15px",
                    cursor: "pointer",
                  }}
                  onClick={handleSignin}
                >
                  <b>Sign in?</b>{" "}
                </a>
                and take the benefit of our Referral Reward Program
              </div>
            </Box>
            <Box sx={{ border: "1px solid black", marginTop: "20px" }}></Box>{" "}
            <br></br>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginTop: "-2px",
                // border:"1px solid red",
              }}
            >
              <Box
                sx={{
                  width: "50%",
                  margin: "-6px 0px 0px -10px",
                  cursor: "pointer",
                  display: "flex",
                }}
                onClick={() => window.open("tel:+918586023109", "_self")}
              >
                <div style={{ fontSize: "14px", color: "#002C51" }}>
                  <PhoneIcon
                    sx={{
                      margin: "8px 3px 0px 4px",
                      color: "#002C51",
                      width: 18,
                      height: 16,
                    }}
                    fontSize="small"
                  />

                  {/* <b>Contact us</b> */}
                </div>
                <div style={{ fontSize: "16px", marginTop: "5px" }}>
                  +91 124 668 7770
                </div>
              </Box>
              <Box
                sx={{
                  width: "50%",
                  margin: "0px 5px 0px 0px",
                  display: "flex",
                }}
              >
                <div
                  style={{
                    fontSize: "14px",
                    color: "#002C51",
                    marginLeft: "-5px",
                  }}
                >
                  <MailIcon
                    sx={{ margin: "3px 5px -3px -5px", color: "#002C51" }}
                    fontSize="small"
                  />
                </div>
                <a
                  href="mailto:partnership@InvesTek.in"
                  style={{ color: "blue", textDecoration: "none" }}
                >
                  <div style={{ fontSize: "16px" }}>
                    partnership@InvesTek.in
                  </div>
                </a>
              </Box>
            </Box>
          </Box>
        </span>
      ) : (
        <span>
          <Box sx={styles.formbox}>
            <Box>
              <img src={investekLogo} alt="img" />
              <Typography sx={{ fontSize: "20px" }}>
                <b>Amigo team welcomes you!</b>
              </Typography>
              <div>Would you like to refer a friend / family member?</div>
              <Button sx={styles.btn} variant="text" onClick={handleSignup}>
                Sign Up
              </Button>
            </Box>
            <Box>
              <Typography sx={{ fontSize: "20px" }}>
                <b>Would you like to know about our</b>
              </Typography>
              <div>Partnership Program?</div>
              <Button onClick={handleContactus} sx={styles.btn} variant="text">
                Contact Us
              </Button>
            </Box>
            <Box>
              <div>
                <a
                  style={{
                    color: "#002c51",
                    fontSize: "15px",
                    cursor: "pointer",
                  }}
                  onClick={handleSignin}
                >
                  <b>Sign in?</b>{" "}
                </a>
                and take the benefit of our Partnership Program
              </div>
            </Box>
            <Box sx={{ border: "1px solid black", marginTop: "20px" }}></Box>{" "}
            <br></br>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginTop: "-14px",
              }}
            >
              <Box
                sx={{
                  width: "40%",
                  cursor: "pointer",
                  display: "flex",
                  marginLeft: "1rem",
                }}
                onClick={() => window.open("tel:+918586023109", "_self")}
              >
                <div style={{ fontSize: "16px", color: "#002C51" }}>
                  <PhoneIcon
                    sx={{
                      margin: "8px 5px 0px 0px",
                      color: "#002C51",
                      width: 18,
                      height: 16,
                    }}
                    fontSize="small"
                  />

                  {/* <b>Contact us</b> */}
                </div>
                <div style={{ fontSize: "16px", marginTop: "5px" }}>
                  +91 124 668 7770
                </div>
              </Box>
              <Box
                sx={{ width: "20%", display: "flex", justifyContent: "center" }}
              >
                <Box
                  sx={{
                    width: "32px",
                    height: "32px",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "#e6e6e6",
                    marginTop: "10px",
                    // marginRight: "18px"
                  }}
                >
                  <Typography sx={{ fontSize: "16px" }}>or</Typography>
                </Box>
              </Box>
              <Box
                sx={{
                  width: "40%",
                  display: "flex",
                  marginRight: "1rem",
                  marginTop: "4px",
                }}
              >
                <div
                  style={{
                    fontSize: "16px",
                    color: "#002C51",
                    marginLeft: "-5px",
                  }}
                >
                  <MailIcon
                    sx={{ margin: "3px 5px -3px 0px", color: "#002C51" }}
                    fontSize="small"
                  />
                </div>
                <a
                  href="mailto:partnership@InvesTek.in"
                  style={{ color: "blue", textDecoration: "none" }}
                >
                  <div style={{ fontSize: "16px" }}>
                    partnership@InvesTek.in
                  </div>
                </a>
              </Box>
            </Box>
          </Box>
        </span>
      )}
    </>
  );
};

export default Signup;

const styles = {
  formbox: {
    position: "absolute",
    top: "51.5%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    padding: "15px",
    background: "#FFFFFF",
    borderRadius: "8px",
    textAlign: "center",
    height: "500px",
    width: "450px",
  },
  formboxresponsive: {
    position: "absolute",
    top: "51.5%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    padding: "15px",
    background: "#FFFFFF",
    borderRadius: "8px",
    textAlign: "center",
    height: "510px",
    width: "335px",
    overflow: "auto",

    scrollbarWidth: "thin",
    scrollbarColor: "#d9d9d9 #fff",
    "&::-webkit-scrollbar": {
      width: "2px",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#d9d9d9",
    },
  },
  formboxtwo: {
    position: "absolute",
    top: "85%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    padding: "15px",
    background: "#FFFFFF",
    borderRadius: "8px",
    textAlign: "center",
    height: "40px",
    width: "420px",
  },
  btn: {
    margin: "1em 0em 1.5em 0em",
    width: "164px",
    backgroundColor: "#002C51",
    color: "white",
    textTransform: "none",
    "&:hover": {
      background: "#002C51",
    },
    border: "none",
  },

  // emailLink: {
  //   // marginLeft: "3.8rem",
  //   color: "red",
  //   fontSize: "15px",
  //   textDecoration: "none",
  //   // transition: "color 0.3s",
  //   "&:hover": {
  //     color: "#002C51 ",
  //   },
  // },
};
